<ng-container *ngIf="data">
  <div class="row header-section justify-content-between align-items-center"  >
      <!-- Back to Selection Button -->
      <div class="col-md-4 text-left">
      <button
        class="btn btn-outline align-items-left"
        *ngIf="!isMenuSeletionsVisible()"
        (click)="showMenuSelection = true">
        <i class="bi bi-arrow-left "></i>
        Back to Selection
         <style> i:hover { -webkit-text-stroke: 1px; } </style></button>
         <button
         class="btn btn-outline   align-items-left"
         *ngIf="isMenuSeletionsVisible()"
         [routerLink]="['/user']">
         <i class="bi bi-arrow-left "></i>
         Back to models
          <style> i:hover { -webkit-text-stroke: 1px; } </style>
       </button>
      </div>

    <!-- Centered Page Title -->
    <div class="col-md-4 text-center">
      <div class="page-title">COMPARISON</div>
    </div>

    <div class="col-md-4 text-center"> </div>
  </div>

  <!-- Selection Card - Only visible when menu selections are visible -->
  <div class="col-12" *ngIf="isMenuSeletionsVisible()">
    <div class="row">
      <!-- Selected Models Section -->
      <div class="col-md-3 sticky-selected-models">
        <div class="sidebar selected-models-section">
          <div class="sidebar-header">
            <h5>Selected Models</h5>
          </div>
          <div class="sidebar-body">
            <ul class="sidebar-list selected-models-list">
              <li class="list-group-item" *ngFor="let model of selectedModels">

                  {{ model.projectName }}

              </li>
            </ul>
            <p class="text-sm-start" *ngIf="selectedModelsMessage">
              {{ selectedModelsMessage }}
            </p>
          </div>

          <!-- Clear and Compare Buttons -->
          <div class="selection-buttons">
            <div class="row g-2">
              <div class="col-6">
                <button
                  class="btn btn-secondary w-100"
                  ngbTooltip="Clear Selection"
                  (click)="clearSelectedModels()"
                  style="white-space: nowrap;"
                >
                  Clear
                </button>
              </div>
              <div class="col-6">
                <button
                  class="btn btn-primary w-100"
                  (click)="comparison()"
                  [disabled]="isCompareButtonDisabled()"
                  style="white-space: nowrap;"
                >
                  Compare
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Card Grid Section -->
      <div class="col-9">
        <!-- Back Button -->
        <div class="mb-3" *ngIf="showBackButton || selectedNodeForModelSelection">
          <button class="btn btn-outline" (click)="navigateBack()">
            <i class="bi bi-arrow-left"></i>
            {{ selectedNodeForModelSelection ? 'Back to Types' : 'Back to Regions' }}
          </button>
        </div>

        <!-- Region Name Header -->
        <div class="region-header mb-4" *ngIf="navigationStack.length > 0">
          <h3 class="region-title">
            <img [src]="getIcon('Region')" class="region-icon">
            {{ navigationStack[navigationStack.length - 1].description }}
          </h3>
        </div>

        <div class="card-grid" [ngClass]="{'model-selection-mode': selectedNodeForModelSelection}">
          <!-- Selected Card and Model Table Container -->
          <div class="selected-card-container" *ngIf="selectedNodeForModelSelection">
            <div class="selected-card">
              <app-tree-card
                [node]="selectedNodeForModelSelection"
                [isSelected]="true"
                (onModelSelected)="addModelToSelection($event)"
                (onModelDeselected)="removeModelFromSelection($event)"
                (onNodeSelected)="navigateToNode($event)">
              </app-tree-card>
            </div>
            <div class="model-table-container">
              <div class="model-table-header">
                <h4>Select Options</h4>
              </div>
              <div class="model-search-container">
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="modelSearchText"
                  (ngModelChange)="filterModels()"
                  placeholder="Search models..."
                >
              </div>
              <div class="model-table">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th scope="col">Select</th>
                      <th scope="col">Option Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let model of filteredModels">
                      <td>
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            [id]="'model-' + model.id"
                            [checked]="isModelSelected(model)"
                            (change)="toggleModelSelection(model, ($any($event.target).checked))">
                        </div>
                      </td>
                      <td>{{ model.name }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Regular Card Grid -->
          <ng-container *ngIf="!selectedNodeForModelSelection">
            <div class="card-item" *ngFor="let node of currentLevelNodes">
              <app-tree-card
                [node]="node"
                [isSelected]="selectedNodeForModelSelection === node"
                (onModelSelection)="selectedNodeForModelSelection = $event"
                (onNodeSelected)="navigateToNode($event)">
              </app-tree-card>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <!-- Comparison view - Only visible when menu selections are not visible -->
  <div class="row" *ngIf="!isMenuSeletionsVisible()">
    <!-- Toggle Button Below Filters -->
    <div class="text-left mt-4 d-flex justify-content-between">

    <div class="col-md-6 text-left">

        <div class="container-fluid  d-flex h-20 flex-wrap align-items-center">
          <button class="btn btn-outline rounded-circle  border-0" (click)="toggleSidebar()"  ngbTooltip="Show/Hide Filter">
            <i class="ml-2" [ngClass]="showSidebar ? 'bi bi-funnel-fill' : 'bi bi-funnel'"></i>
          </button>
          <div class="filter-alert col-md-6 text-left"   *ngIf="isFilterActive()" >
            <span class="text-warning">Filters Are Active</span>
          </div>
        </div>


    </div>


      <div class="d-flex align-items-center">
        <div container="body" ngbDropdown #dropdownExcel="ngbDropdown">
          <button
            class="btn btn-outline rounded-circle border-0"
            title="Export to XLS"
            (click)="exportTo('excel')"
          >
            <div class="icon icon-excel"></div>
          </button>
        </div>
        <div container="body" ngbDropdown #dropdownPdf="ngbDropdown">
          <button
            class="btn btn-outline rounded-circle border-0"
            title="Export to PDF"
            (click)="exportTo('pdf')"
          >
            <div class="icon icon-pdf"></div>
          </button>
        </div>
      </div>

    </div>
      <!-- Sidebar for filters -->
      <div class="col-md-3" *ngIf="showSidebar">
        <div class="filter-sidebar">
          <div class="filters">
            <h5>Filters</h5>
            <!-- divader -->
            <hr class="horizontal-divider" />

            <label for="comparisonFilter">Filter by Comparison Result:</label>
            <select id="comparisonFilter" (change)="onComparisonFilterChange($event)"
                                          [(ngModel)]="comparisonFilter"
            >
              <option value="All">All</option>
              <option value="Match">Match</option>
              <option value="Mismatch">Mismatch</option>
            </select>

            <label>Filter by Category:</label>
            <div class="category-checkboxes">
              <div>
                <input
                  type="checkbox"
                  id="selectAllCategories"
                  [checked]="isAllCategoriesSelected()"
                  (change)="onSelectAllCategories($event)"
                />
                Select All
                <div *ngFor="let item of checkboxItems">
                  <input
                    type="checkbox"
                    [checked]="item.checked"
                    (change)="toggleCheckbox(item)"
                  />
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Main content area -->
      <div [class.col-md-9]="showSidebar" [class.col-md-12]="!showSidebar">



        <div class="row justify-content-center">
          <div class="col-12">
            <div class="table-container">
              <table class="table table-borderless bom-table m-0 mat-elevation-z8">
                <thead class="table-header">
                  <!-- Table headers -->
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Item Name</th>
                    <th scope="col" >Size</th>
                    <th scope="col">Description</th>
                    <th scope="col">Waste Factor</th>
                    <th scope="col">Units of Measurement</th>
                    <th scope="col" *ngFor="let key of combinedQuantityKeys">{{ key.toUpperCase().replace('_', ' ') }}</th>
                  </tr>
                </thead>
                <tbody class="table-body">
                  <!-- Table body content -->
                  <ng-container *ngFor="let category of groupedData">
                    <tr>
                      <td colspan="16" class="category-header" >
                        {{ category.name }}
                      </td>
                    </tr>
                    <ng-container *ngFor="let groupedSubCategory of category.bgGroupedSubCategories">
                      <tr >
                        <td colspan="16" class="grouped-subcategory-header"  *ngIf="groupedSubCategory.name.toLowerCase() !== 'default'">
                          {{ groupedSubCategory.name }}
                        </td>
                      </tr>
                      <ng-container *ngFor="let subCategory of groupedSubCategory.bgSubCategories">
                        <tr
                        [ngClass]="{
                          'total-row-header':  subCategory.name.toLowerCase().startsWith('total'),

                        }"
                        >
                          <td
                             colspan="16"
                            class="subcategory-header"
                             >
                            {{ subCategory.name }}
                          </td>
                        </tr>
                        <!-- Render the items -->
                        <ng-container *ngFor="let item of subCategory.combinedBgBomItems; let i = index">
                          <tr
                          [ngClass]="{
                            'total-row-odd': subCategory.name.toLowerCase().startsWith('total') && (i + 1) % 2 === 1,
                            'total-row-even': subCategory.name.toLowerCase().startsWith('total') && (i + 1) % 2 === 0
                          }"
                        >
                            <td>{{" "}}</td>
                            <td>{{ item.itemName }}</td>
                            <td>{{ item.size }}</td>
                            <td>{{ item.description }}</td>
                            <td>{{ item.wasteFactor }}</td>
                            <td>{{ item.quantityToOrderDescription }}</td>
                            <td *ngFor="let key of combinedQuantityKeys">
                              {{ item.combinedQuantityToOrder[keyMapping[key]] || '-' }}
                            </td>
                          </tr>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
</ng-container>



